module.exports = __webpack_public_path__ + "static/media/scan_0008.84d4ad29.jpg";